import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import dotenv from 'dotenv';
import { Eye } from 'react-preloading-component';

import App from '../App';
import StyledSpinner from '../styles/Spinner';

dotenv.config();

const { REACT_APP_PLACES_API_KEY } = process.env;

const CustomHelmet = () => {
  const [mapLoaded, setMapLoaded] = useState(false);

  useEffect(() => {
    window.onGoogleMap = () => setMapLoaded(true);

    return () => {
      delete window.onGoogleMap;
    };
  }, []);

  return (
    <div>
      <Helmet>
        <script
          src={`https://maps.googleapis.com/maps/api/js?key=${REACT_APP_PLACES_API_KEY}&libraries=places&callback=onGoogleMap`}
        ></script>
      </Helmet>

      {!mapLoaded ? (
        <StyledSpinner>
          <Eye color='#ffffff' size='25' />
        </StyledSpinner>
      ) : (
        <App />
      )}
    </div>
  );
};

export default CustomHelmet;
